import './assets/Schema.css';const o = "_group_ka6jg_6", a = "_accordion_ka6jg_10", e = "_rowDescription_ka6jg_13", t = "_header_ka6jg_65", _ = "_arrow_ka6jg_69", r = "_hand_ka6jg_75", n = "_rotate_ka6jg_1", s = "_scrollArea_ka6jg_79", c = "_scrollBar_ka6jg_83", i = "_scrollThumb_ka6jg_89", l = "_tableHeader_ka6jg_95", d = "_firstHead_ka6jg_107", g = "_invisibleHeader_ka6jg_118", h = "_headContent_ka6jg_124", j = "_whiteBoxHeader_ka6jg_130", k = "_firstCol_ka6jg_138", w = "_tableContents_ka6jg_145", H = "_icon_ka6jg_152", b = "_whiteBoxRow_ka6jg_159", p = "_show_ka6jg_167", u = "_noShow_ka6jg_168", B = "_optionalHeader_ka6jg_183", C = "_optionalSubHeader_ka6jg_192", S = {
  group: o,
  accordion: a,
  rowDescription: e,
  header: t,
  arrow: _,
  "arrow-movement": "_arrow-movement_ka6jg_1",
  hand: r,
  rotate: n,
  scrollArea: s,
  scrollBar: c,
  scrollThumb: i,
  tableHeader: l,
  firstHead: d,
  invisibleHeader: g,
  headContent: h,
  whiteBoxHeader: j,
  firstCol: k,
  tableContents: w,
  icon: H,
  whiteBoxRow: b,
  show: p,
  noShow: u,
  optionalHeader: B,
  optionalSubHeader: C
};
export {
  S
};
